import React from "react";
import { makeStyles } from "@material-ui/core/styles";

export const SPLASH_LOADER_DURATION_MS = 4000;

const useStyles = makeStyles((theme) => {
    const contrastColor = "#ffffff";
    const contourColor = theme.palette.primary.main || "#16a658";
    const greenAnimation = `$outlineToSolidGreen ${SPLASH_LOADER_DURATION_MS}ms ease-in-out 1 forwards`;
    const whiteAnimation = `$outlineToSolidWhite ${SPLASH_LOADER_DURATION_MS}ms ease-in-out 1 forwards`;

    return {
        loaderBox: {
            width: 250,
            height: 250,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
        },
        baseSvg: {
            width: 200,
            height: 200,
            overflow: "visible",
        },
        pathBranco: {
            fill: "transparent",
            stroke: contourColor,
            strokeWidth: 3,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            animation: whiteAnimation,
        },
        pathVerde: {
            fill: "transparent",
            stroke: theme.palette.primary.main || "#16a658",
            strokeWidth: 3,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            animation: greenAnimation,
        },
        "@keyframes outlineToSolidGreen": {
            "0%, 10%": {
                fill: "transparent",
                strokeDasharray: 4000,
                strokeDashoffset: 4000,
            },
            "50%": {
                fill: "transparent",
                strokeDasharray: 4000,
                strokeDashoffset: 0,
            },
            "70%, 100%": {
                fill: theme.palette.primary.main || "#16a658",
                strokeDashoffset: 0,
            },
        },
        "@keyframes outlineToSolidWhite": {
            "0%, 10%": {
                fill: "transparent",
                stroke: contourColor,
                strokeDasharray: 4000,
                strokeDashoffset: 4000,
            },
            "50%": {
                fill: "transparent",
                stroke: contourColor,
                strokeDasharray: 4000,
                strokeDashoffset: 0,
            },
            "70%, 100%": {
                fill: contrastColor,
                stroke: contrastColor,
                strokeDashoffset: 0,
            },
        },
    };
});

const SplashLoader = () => {
    const classes = useStyles();

    return (
        <div className={classes.loaderBox}>
            <svg
                className={classes.baseSvg}
                viewBox="0 0 450 400"
                preserveAspectRatio="xMidYMid meet"
            >
                <g>
                    <g>
                        <path
                            className={classes.pathVerde}
                            d="M221.81,13.79c40.15,0,80.3.06,120.46-.03,15.14-.03,29.32,3.23,42.23,11.29,20.76,12.95,33.47,31.44,37.73,55.54.98,5.55,1.21,11.25,1.21,16.92,0,52.31.46,104.63-.14,156.94-.24,20.6-8.37,38.72-23.18,53.53-13.41,13.41-29.54,21.2-48.29,23.66-1.64.22-3.32.18-4.99.19-22.49.16-44.98.16-67.47.5-35.98.55-71.96-.32-107.94-.17-5.76.02-10.16,1.89-14.24,5.78-15.53,14.85-31.41,29.32-47.65,43.39-1.92,1.66-3.75,4.52-6.78,3.27-3.38-1.39-2.24-4.84-2.3-7.52-.26-12.82.24-25.66-.69-38.47-.37-5.09-.41-5.13-5.55-6.37-17.3-4.19-32.77-11.83-45.39-24.58-14.56-14.71-22.37-32.39-22.4-53.22-.07-53.65-.17-107.3-.03-160.94.08-28.83,13.43-50.83,36.2-67.59,8.29-6.1,17.69-9.73,27.8-11.62,2.66-.5,5.3-.43,7.96-.43,41.15-.02,82.3-.01,123.46-.01,0-.02,0-.04,0-.07ZM207.24,68.61c-1.02,1.91-.78,3.27-.78,4.56-.01,10.83-.02,21.66.06,32.48.04,5.76.81,6.5,6.61,6.87.83.05,1.67.04,2.5.04,29.65.03,59.3.06,88.96.12,1.21,0,2.52-.44,4.06.43-6.74,8.6-13.31,16.93-19.82,25.31-16.84,21.68-33.67,43.36-50.45,65.09-8.12,10.53-16.5,20.87-23.56,32.18-1.83,2.93-2.68,5.94-2.59,9.42.22,8.32.27,16.66.24,24.98,0,3.19.52,6.22,1.45,9.38,52.11,1.09,104.13,1.46,156.52,1.52,0-1.87,0-3.34,0-4.82,0-10.83,0-21.66-.01-32.48,0-8.63-.09-8.66-8.55-8.76-27.15-.32-54.3.25-81.44-.98-1.58-.07-3.27.34-5.09-.85,1.14-1.7,2.14-3.39,3.33-4.93,10.24-13.32,20.49-26.62,30.76-39.91,18.61-24.09,36.72-48.54,53.99-73.62,4.33-6.29,6.8-12.68,6.03-20.42-.71-7.12-.71-14.3-1.15-21.44-.26-4.19-1.05-4.84-5.17-4.96-.67-.02-1.33,0-2,0-37.32.02-74.63-.02-111.95.1-13.98.04-27.96.45-41.96.69ZM218.33,185.12c-1.02-1.24-1.75-2.15-2.51-3.04-23.27-27.42-45.91-55.37-68.19-83.6-7.22-9.14-14.29-18.4-21.4-27.63-1.72-2.23-3.63-3.58-6.7-3.51-11.83.26-23.66.27-35.49.43-3.83.05-4.33.54-4.53,4.3-.35,6.49-.83,12.98-.84,19.47-.11,61.66-.14,123.32-.17,184.98,0,1.28-.36,2.65.45,4,.41.1.87.3,1.33.3,13.32-.21,26.66.43,39.96-.85,4.95-.48,5.13-.54,5.23-5.77.25-12.49.6-24.99.67-37.48.16-28.33.18-56.66.26-84.99,0-1.2,0-2.4,0-4.34,25.45,27.78,48.88,56.02,73.42,83.75,5.85-15.9,13.06-30.48,18.51-46.01Z"
                        />
                        <path
                            className={classes.pathBranco}
                            d="M207.24,68.61c14-.24,27.98-.64,41.96-.69,37.31-.12,74.63-.08,111.95-.1.67,0,1.33-.01,2,0,4.11.13,4.91.78,5.17,4.96.44,7.15.45,14.33,1.15,21.44.77,7.74-1.7,14.13-6.03,20.42-17.27,25.08-35.38,49.53-53.99,73.62-10.27,13.29-20.53,26.59-30.76,39.91-1.18,1.54-2.18,3.22-3.33,4.93,1.82,1.19,3.51.77,5.09.85,27.14,1.23,54.29.66,81.44.98,8.46.1,8.54.13,8.55,8.76,0,10.83,0,21.66.01,32.48,0,1.48,0,2.95,0,4.82-52.39-.06-104.42-.42-156.52-1.52-.93-3.17-1.46-6.2-1.45-9.38.03-8.33-.02-16.66-.24-24.98-.09-3.48.75-6.48,2.59-9.42,7.07-11.31,15.44-21.65,23.56-32.18,16.77-21.73,33.61-43.41,50.45-65.09,6.51-8.38,13.09-16.71,19.82-25.31-1.54-.87-2.85-.43-4.06-.43-29.65-.06-59.3-.09-88.96-.12-.83,0-1.67.02-2.5-.04-5.8-.37-6.57-1.11-6.61-6.87-.07-10.83-.07-21.66-.06-32.48,0-1.3-.24-2.65.78-4.56Z"
                        />
                        <path
                            className={classes.pathBranco}
                            d="M218.33,185.12c-5.45,15.53-12.66,30.12-18.51,46.01-24.54-27.73-47.96-55.97-73.42-83.75,0,1.94,0,3.14,0,4.34-.08,28.33-.1,56.66-.26,84.99-.07,12.49-.42,24.99-.67,37.48-.1,5.23-.28,5.29-5.23,5.77-13.3,1.29-26.64.64-39.96.85-.46,0-.92-.2-1.33-.3-.82-1.35-.45-2.71-.45-4,.03-61.66.06-123.32.17-184.98.01-6.49.49-12.98.84-19.47.2-3.77.71-4.25,4.53-4.3,11.83-.16,23.66-.17,35.49-.43,3.07-.07,4.98,1.28,6.7,3.51,7.11,9.23,14.19,18.48,21.4,27.63,22.28,28.23,44.92,56.17,68.19,83.6.75.89,1.48,1.8,2.51,3.04Z"
                        />
                    </g>
                </g>
            </svg>
        </div>
    );
};

export default SplashLoader;
